module.exports = __webpack_public_path__ + "static/media/22861516_1638434389565079_594111357368904551_o-thumb.20f42c1b.jpg";